<script>
  import { onMount } from 'svelte'
  import { site } from './store.js'

  onMount(() => {
    jQuery('.carousel').on('init', function(event, slick, currentSlide, nextSlide){
      setTimeout(function(){
        jQuery('.slick-current').addClass('to-show');
      },500);
    });

    jQuery('.carousel').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 5000
    });

    jQuery('.carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      jQuery('.slick-current').addClass('to-hide');
    });
    jQuery('.carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
      jQuery('.slick-current').addClass('to-show');
      jQuery('.slick-slide.to-hide').removeClass('to-hide to-show');
    });
  })
</script>

<div class="carousel">
  {#each $site.home.carousel as slide}
    <div class="slide-content carousel-item" style="background-image: url({ slide.img });" >
      <div class="inner">
        <div class="carousel-text-section" style="height: 400px;">
          <h3>{ slide.title }</h3>
          <div class="carousel-text">
            <span></span>
            <p>{ slide.body }</p>
            <a class="read-more" href={ slide.url }>READ MORE<span class="screen-reader-text">{ slide.title }</span></a>
          </div>
        </div>
      </div>
    </div>
  {/each}
</div>
